import * as React from "react";

import { FloatingPortal, useMergeRefs } from "@floating-ui/react";

import { usePopoverContext } from "./context";

export const _PopoverContent = React.forwardRef<HTMLDivElement, React.HTMLProps<HTMLDivElement>>(
  ({ style, ...props }, propRef) => {
    const { context, refs, floatingStyles, getFloatingProps } = usePopoverContext();
    const ref = useMergeRefs([refs.setFloating, propRef]);

    if (!context.open) return null;

    return (
      <FloatingPortal>
        {/* This is used to prevent the content from being scrolled out of view or outside click action */}
        <div style={{ height: "100%", width: "100%", position: "absolute" }} />
        <div
          {...props}
          ref={ref}
          style={{ ...floatingStyles, ...style }}
          {...getFloatingProps(props)}
        />
      </FloatingPortal>
    );
  }
);
